import { module } from 'modujs';
import Lenis from '@studio-freight/lenis'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import LazyLoad from 'vanilla-lazyload';
gsap.registerPlugin(ScrollTrigger);
import Ukiyo from "ukiyojs";


export default class extends module {
    constructor(m) {
        super(m);
    }
    init() {
        this.lenis = new Lenis( { wrapper: this.el, content: this.$( 'content' )[0],  smoothTouch: true, syncTouch: true });
        this.lenis.on('scroll', () => ScrollTrigger.update());
        const scrollFn = (time) => {
            this.lenis.raf(time);
            requestAnimationFrame(scrollFn);
        };
        requestAnimationFrame(scrollFn);
        // LAZY LOAD
        this.lazy = new LazyLoad({ elements_selector : "[data-lazy]", container: this.el });
        // PARALLAX
        this.ukiyo = new Ukiyo( document.querySelectorAll("[data-parallax]"), { scale: 1.2, willChange: true } );
    }

    updateLazy(){
        this.lazy.update();
    }

    scrollTo( args ){
        this.lenis.scrollTo( args.target, args.options || {} );
    }

    update(){
        ScrollTrigger.update();
        this.lenis.dimensions.onContentResize();
    }

    start(){
        this.lenis.start();
    }

    stop(){
        this.lenis.stop();
    }

    destroy(){
        this.lenis.destroy();
        this.ukiyo.destroy();
    }
}
